import { fetch } from '@/utils/fetch';

/**
 * 获取个人银行卡信息
 */
export const getOwnerBankAccount = (loanBillOID, userOID) => {
  let url;
  if (loanBillOID && userOID) {
    url = `/api/repayment/contact/bank?loanBillOID=${loanBillOID}&userOID=${userOID}`;
  } else {
    url = '/api/contact/bank/account/my';
  }
  return fetch({
    url: url,
    method: 'GET',
  });
};
/**
 * 获取银行列表
 * @param {Object} 获取银行信息的object
 */
export const getAllBank = ({ page = 0, size = 20, keyword = '' }) => {
  return fetch({
    url: '/api/repayment/bank/list',
    method: 'GET',
    params: {
      page,
      size,
      bankName: keyword,
    },
  });
};

/**
 * 根据账套id或用户oid查询法人实体信息
 */
export const getLegalentitysByOID = ({ setOfBooksId = '', userOID = '' }) => {
  return fetch({
    url: '/api/legalentitys/by/setofbooks/or/user',
    method: 'GET',
    params: {
      setOfBooksId,
      userOID,
    },
  });
};

/**
 * 根据code获取币种名称
 * @param code
 * @param language
 */
export const getCurrencyNameFromCode = (code, language) => {
  let handleLanguage = function (language) {
    if (language === 'en') {
      return 'englishName';
    } else {
      return 'chineseName';
    }
  };
  return fetch({
    url: '/api/Currency/Language/getCurrencyNaemByLanguage',
    method: 'GET',
    params: {
      code: code,
      language: handleLanguage(language),
    },
  });
};

export const locationSearch = (vendorType, keyWord, page, headers) => {
  return fetch({
    url: '/location-service/api/location/search',
    method: 'GET',
    params: {
      vendorType: vendorType,
      keyWord: keyWord,
      page: page,
    },
    headers: headers,
  });
};

/**
 * 获取指定人员信息
 * @param userOID
 * @returns {*}
 */
export const getUserInfo = (userOID) => {
  return fetch({
    url: `/api/users/proxy/${userOID}`,
    method: 'GET',
  });
};

/**
 * 获取指定人员公司配置
 * @param useroid
 * @returns {*}
 */
export const getUserCompany = (useroid) => {
  return fetch({
    url: '/api/company/user',
    method: 'GET',
    params: {
      useroid,
    },
  });
};

/**
 * 获取指定人员fp
 * @param userOID
 * @returns {*}
 */
export const getUserFunctionProfile = (userOID) => {
  return fetch({
    url: `/api/function/profiles/${userOID}`,
    method: 'GET',
  });
};

export const getVendorUrl = (supplierOID, direction = 'H5', pageType = '1002', accessToken, refreshToken) => {
  return fetch({
    url: '/vendor-info-service/api/sso/common',
    method: 'GET',
    params: {
      supplierOID,
      direction,
      pageType,
      // accessToken,
      // refreshToken,
    },
  });
};

export const getfeedbackInfo = ({
  codes = ['MODULE', 'TAG', 'CHANNEL', 'PLATFORM'].join(','),
  customEnumerationType,
  language,
} = {}) => {
  return fetch({
    url: '/api/operation/enum/item/code',
    method: 'GET',
    params: {
      codes,
      customEnumerationType,
      language,
    },
  });
};

export const postFeedbackContent = (data) => {
  return fetch({
    url: '/api/operation/feedback',
    method: 'POST',
    data,
  });
};

export const postWxStaticImage = (data) => {
  return fetch({
    url: '/api/wechat/upload/wxattachment/static',
    method: 'POST',
    data: data,
  });
};

export const postUploadAttachmentData = ({
  attachmentType = 'OTHER',
  files = [],
  url = '/api/upload/attachment/batch',
  name = 'files',
  useReportService = false,
}) => {
  let formData = new FormData();
  files.forEach((file) => {
    formData.append(name, file);
  });
  formData.append('attachmentType', attachmentType);
  return fetch({
    url: useReportService ? `/report${url}` : url,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  });
};
/**
 *
 * entityOID 表单oid
 * type
 *  DOCUMENT 报销单
 *  INVOICE 费用
 *  RECEIPT 发票
 *  APPORTIONMENT 分摊行
 *  BANKCARD 商务卡
 */
export const getAnnotateByEntityOID = (entityOID, type) => {
  return fetch({
    url: `/api/report/note/${entityOID}`,
    method: 'GET',
    params: {
      type,
    },
  });
};

/*
 * 获取角色配置信息（角色及手机号）
 * */
export const getRoleConfig = () => {
  return fetch({
    url: '/api/authorization/policy/role/config',
    method: 'GET',
  });
};

/*
 * 更新角色配置信息(手机号)
 * */
export const postRoleConfig = (mobile, token) => {
  return fetch({
    url: '/api/authorization/policy/role/config',
    method: 'POST',
    data: {
      mobile: mobile,
      client: 'app',
      token: token,
      cryptType: '2.3',
    },
  });
};

/*
 * 更新角色信息
 * */
export const postRolePolicy = ({ params = {}, data = {} }) => {
  return fetch({
    url: 'api/authorization/policy/detail/batch/v2',
    method: 'POST',
    params,
    data,
  });
};

/*
 * 获取手机验证码
 * @params mobile Number 手机号 需要加密
 * */
export const getMobileValidateCode = (mobile) => {
  return fetch({
    url: '/api/refactor/set/mobile/token/v3',
    method: 'GET',
    params: {
      mobile,
      client: 'app',
      yzmYesOrNo: false,
      cryptType: '2.3',
    },
  });
};

export const postUploadAvatar = (file) => {
  let formData = new FormData();
  formData.append('file', file);
  return fetch({
    url: '/api/contact/add/headPortrait',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  });
};

export const getInfoDisplayData = (params) => {
  return fetch({
    url: '/api/userFieldFormSetting',
    method: 'get',
    //inf-95122 【银行卡】/api/userFieldFormSetting 500
    /*headers: {
      'Content-Type': 'multipart/form-data',
    },*/
    params,
  });
};

// 获取子应用菜单权限
export const getAllSubMenuPermission = () => {
  return fetch({
    url: '/mobile/api/work/gui/widget/sub/menu/permission',
    method: 'GET',
  });
};

export const getUserDisplayInfo = () => {
  return fetch({
    url: '/api/user/dynamicInfo/serializable',
    method: 'GET',
  });
};

//获取用户信息v2
export const getUserInfoNew = (userOID, params) => {
  if (!userOID) {
    return Promise.reject({});
  }
  return fetch({
    url: `/api/users/v2/${userOID}`,
    method: 'GET',
    params,
  });
};

// 根据code获取操作指引，参数传数组，支持批量查询
export const getAnswerLink = (data) => {
  return fetch({
    url: 'api/operation/commonproblem/codes?type=QUICKSTART',
    method: 'POST',
    data,
  });
};

//
export const getCostCenterSettings = () => {
  return fetch({
    url: '/api/cost/center/option',
    method: 'GET',
  });
};

export const getIsAtDiagnosis = (userOID) => {
  sessionStorage.removeItem('hly.superTraceId');
  return fetch({
    url: `/api/supertrace/getTraceConfigByUser/${userOID}`,
    method: 'GET',
  });
};

export const endDiagnosis = () => {
  return fetch({
    url: '/api/user/operation/end/operation',
    method: 'POST',
  });
};

// 避免引入整个申请单的service
// 分摊是否隐藏权限
/**
 * @param entityOID  单据OID
 * @param entityType 单据entityType
 * @param approverOID 审批节点的OID
 * @returns {*|Promise<unknown>}
 */
export const getNodeApportionConfig = ({ entityOID, entityType, approverOID }) => {
  const params = {
    entityOID,
    entityType,
    approverOID: approverOID || undefined,
  };
  return fetch({
    url: '/api/approval/node/apportionment/permission',
    method: 'GET',
    params,
  });
};
